import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Sirve si nunca usé Excel?',
  answer: 'Sí. Las planillas están diseñadas para usarse sin conocimientos técnicos. Si podés escribir en una celda, podés usar el kit.'
}, {
  question: '¿Es compatible con Mac?',
  answer: '100%. Funciona en Excel, Google Sheets y Numbers. En cualquier dispositivo.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Acceso inmediato después del pago. Descargás todo en un ZIP directo a tu dispositivo.'
}, {
  question: '¿Qué diferencia hay entre los dos planes?',
  answer: 'El Kit Elite tiene las 15 planillas y 4 bonos. El Kit Elite PRO agrega el módulo financiero avanzado con control de honorarios, balance mensual y proyección de ingresos.'
}, {
  question: '¿Lo puede usar todo mi equipo?',
  answer: 'Sí. Una vez descargado podés compartirlo con todo tu personal sin costo adicional.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState(-1);
  return <section className="bg-mint py-12 px-6" data-id="element-88">
      <div className="max-w-md mx-auto space-y-6" data-id="element-89">
        <h2 className="text-2xl font-bold text-navy text-center" data-id="element-90">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-91">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl overflow-hidden border border-navy/10" data-id="element-92">
              <button onClick={() => setOpenIndex(openIndex === index ? -1 : index)} className="w-full flex items-center justify-between p-4 text-left hover:bg-mint/50 transition-colors" data-id="element-93">
                <span className="font-bold text-navy pr-4" data-id="element-94">{faq.question}</span>
                <ChevronDownIcon className={`w-5 h-5 text-navy flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-95" />
              </button>

              <AnimatePresence data-id="element-96">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-97">
                    <div className="px-4 pb-4" data-id="element-98">
                      <p className="text-navy/80 text-[15px] leading-relaxed" data-id="element-99">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}